(function () {
    $(() => {
        if ($('.Share').length) {

        }
    })
})();